import { render } from "./BoxGameType.vue?vue&type=template&id=4847e175"
import script from "./BoxGameType.vue?vue&type=script&lang=js"
export * from "./BoxGameType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__